export enum DownloadFileTypesEnum {
    Excel = 1,
    Other = 2
}



// WEBPACK FOOTER //
// ./src/app/utils/enums/downloadFileTypesEnum.ts